import type { ReactNode } from 'react';
import { LazyMotion, MotionConfig } from 'motion/react';
import { useMovimentoReduzido } from '../lib/movimento';

// Os recursos de animação (inclusive layout e layoutId) chegam num chunk à
// parte, depois do primeiro paint: a página pinta sem esperar o motion.
// Uma segunda tentativa cobre a rede que oscilou; o PWA também guarda o chunk.
const carregar = () => import('../lib/recursos-movimento').then((r) => r.default);
const recursos = () => carregar().catch(carregar);

/**
 * Raiz do motion. `strict` impede `motion.*` (que carrega tudo) e obriga `m.*`.
 * Com movimento reduzido -- pelo sistema OU pela conta -- `always` tira
 * deslocamento e layout de todo componente; a opacidade continua.
 */
export function ProvedorDeMovimento({ children }: { children: ReactNode }) {
  const reduzido = useMovimentoReduzido();
  return (
    <LazyMotion features={recursos} strict>
      <MotionConfig reducedMotion={reduzido ? 'always' : 'never'}>{children}</MotionConfig>
    </LazyMotion>
  );
}
